import { css } from 'emotion'
import { Colors, Link, CardTitle, CardSmall, Easings } from './..'

const defaultCard = (cover, shadow, isCover) => ({
  padding: '0.75rem',
  '.card': {
    '&-bottom': {
      justifyContent: 'flex-end',
    },
    '&-inner': {
      background: 'white',
      boxShadow: shadow ? `0 0 10px 0 ${Colors.shadow}` : '0',
      // overflow: 'hidden',
      '@media (min-width: 1024px)':{
        boxShadow: shadow ? `0 0 20px 0 ${Colors.shadow}` : '0',
      },
      '&:hover': {
        '.card-picture:after': {
          transform: 'scale(1.5)',
          transitionDuration: '1s',
        },
      }
    },
    '&-picture': {
      overflow: 'hidden',
      position: 'relative',
      background: '#000',
      '&:after': {
        content:"''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `#000 url(${cover}) no-repeat center`,
        backgroundSize: isCover ? 'cover' : 'auto 100%',
        transition: `transform 0.5s ${Easings.customEase}`,
        transform: 'scale(1)',
        overflow: 'hidden',
        transformOrigin: 'center center',
        
      }
    },
    '&-info': {
      padding: '1rem',
      '@media (min-width: 1024px)':{
        padding: '1.5rem',
      },
      '&--type': {
        color: Colors.mediumGrey,
        ...Link,
      },
      'p, .description': {
        ...CardSmall,
        color: 'black',
        margin: 0,
        textTransform: 'uppercase',
      }
    },
    '&-link': {
      ...Link,
      fontSize: '0.75rem',
      color: Colors.mediumGrey,
      transition: 'color 400ms ease',
      '@media (min-width: 1024px)': {
        fontSize: '0.825rem'
      }
    }
  },
  'h2': {
    ...CardTitle,
    margin: '0.5rem 0',
    color: 'black',
  },
  '.card-button': {
    display: 'flex',
    width: 60,
    minHeight: 60,
    justifyContent: 'flex-end',
    '@media (min-width: 1024px)':{
      width: 120,
    },
    '.btn-pdf':{
      display: 'none',
      '@media (min-width: 1024px)':{
        display:'block',
      },
    }
  },
  '.btn-pdf':{
    marginRight: 1,
  },
  '&:hover': {
    '.card': {
      '&-link': {
        color: 'black',
      }
    }
  }
})

export const CardStyle = (shadow, cover, isCover) => css({
  maxWidth: '25%',
  flexBasis: '25%',
  minWidth: '280px',
  ...defaultCard(cover, shadow, isCover),
  '&:first-child': {
    paddingLeft: 0,
    paddingRight: '1.4rem',
  },
  '&:last-child': {
    paddingRight: 0,
    paddingLeft: '1.4rem',
  },
  '.card-link': {
    maxWidth: 'calc(100% - 60px)',
    flexBasis: 'calc(100% - 60px)',
    textAlign: 'center',

    '@media (min-width: 1024px)':{
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      maxWidth: 'calc(100% - 120px)',
      flexBasis: 'calc(100% - 120px)',
      textAlign: 'left',
    },
  },
}, {
  '.card-picture': {
    paddingTop: '70%',
  }
})

export const LongCardStyle = (shadow, cover, isCover) => css({
  ...defaultCard(cover,shadow, isCover),
  padding: '1.25rem 0',
  '.card-inner > a:first-child': {
    display: 'flex',
    flexWrap: 'wrap',
  },
  '.card-bottom': {
    alignSelf: 'flex-end',
    width: '100%',
    flexBasis: '100%',
    '@media (min-width: 1024px)':{
      width: 160,
      flexBasis: 160,
    },
  },
  '.card-picture': {
    width: '100%',
    flexBasis: '100%',
    height: 220,
    '@media (min-width: 1024px)':{
      width: 'calc(1/6 * 100%)',
      flexBasis: 'calc(1/6 * 100%)',
      height: 'auto',
    },
  },
  '.card-info': {
    maxWidth: '100%',
    flexBasis: '100%',
    '@media (min-width: 1024px)':{
      maxWidth: 'calc(5/6 * 100% - 160px)',
      flexBasis: 'calc(5/6 * 100% - 160px)',
    },
    'h2': {
      minHeight: '0',
    },
    '.card-info--type': {
      display: 'none',
    },
    '.highlight, .highlight > p': {
      fontSize: '1rem',
      color: 'black',
      'em':{
        color: Colors.red,
        fontStyle: 'normal',
      }
    }
  },
  '.card-link': {
    maxWidth: 'calc(100% - 120px)',
    flexBasis: 'calc(100% - 120px)',
    textAlign:'center',
    '@media (min-width: 1024px)':{
      margin: '2rem 0',
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  '.card-button': {
    width: 120,
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (min-width: 1024px)':{
      width: 160,
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/card.js